import { render, staticRenderFns } from "./paperPreview.vue?vue&type=template&id=3ab98868&scoped=true&"
import script from "./paperPreview.vue?vue&type=script&lang=js&"
export * from "./paperPreview.vue?vue&type=script&lang=js&"
import style0 from "./paperPreview.vue?vue&type=style&index=0&id=3ab98868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab98868",
  null
  
)

export default component.exports